export default "__VITE_ASSET__4f0ae025__"